// Your web app's Firebase configuration

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database"; /*to setup the realtime database*/
import "firebase/storage";


var firebaseConfig = {
    apiKey: "AIzaSyCK6d61NO6nX0yazGLEL7TJrsPTSAEoeis",
    authDomain: "react-slack-clone-redux.firebaseapp.com",
    databaseURL: "https://react-slack-clone-redux.firebaseio.com",
    projectId: "react-slack-clone-redux",
    storageBucket: "react-slack-clone-redux.appspot.com",
    messagingSenderId: "332799210007",
    appId: "1:332799210007:web:583000f6b8df1a4f0de252",
    measurementId: "G-8KE64QE27G"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
 

//   module, making it avaliable
  export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.js